export const SNACKBAR_SHOW_EVENT_NAME = 'snackbar-show-message';
export const SNACKBAR_UPDATE_EVENT_NAME = 'snackbar-update-message';
export const SNACKBAR_REMOVE_EVENT_NAME = 'snackbar-remove-message';
